// extracted by mini-css-extract-plugin
export default {"CustomerListAlert":"CustomerList_CustomerListAlert__RbyFK"};